import { fireLinkTag } from './tagManager';

export default function tagSecondaryPromo(product_id: string, num_offers: number) {
  const data = {
    event_name: 'special offer click',
    product_id,
    num_offers,
  };
  fireLinkTag(data);
}
